export default __webpack_public_path__ + "static/media/carouselImage6.271a4101.jpg";